import styled from "styled-components";

const DynamicFlagImage = styled.img`
  width: 1.75rem;
  height: 1.75rem;
  vertical-align: middle;
  border-radius: 50%;
  object-fit: cover;
  border: 0.08rem solid #ccc;
`;

export { DynamicFlagImage };
